import React, { useState, useEffect } from "react"
import { ChevronUp } from "lucide-react"

const ScrollTopButton = () => {
  const [isVisible, setIsVisible] = useState(false)

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 400) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility)
    return () => window.removeEventListener("scroll", toggleVisibility)
  }, [])

  return (
    <div
      className={`fixed bottom-32 right-10 z-[65] transition-all duration-500 transform ${
        isVisible
          ? "translate-y-0 opacity-100"
          : "translate-y-10 opacity-0 pointer-events-none"
      }`}
    >
      <button
        onClick={scrollToTop}
        className="group relative w-12 h-12 bg-white border-2 border-slate-100 rounded-2xl shadow-xl hover:shadow-vcnr-brand/20 hover:border-vcnr-brand flex items-center justify-center transition-all duration-300 hover:-translate-y-2 active:scale-95 overflow-hidden"
        aria-label="Scroll to top"
      >
        {/* Background Hover Effect */}
        <div className="absolute inset-0 bg-vcnr-brand opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>

        {/* Technical Accent */}
        <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-vcnr-brand/40 to-transparent transform -translate-y-full group-hover:translate-y-0 transition-transform duration-500"></div>

        <ChevronUp
          size={24}
          className="text-slate-400 group-hover:text-vcnr-brand group-hover:-translate-y-1 transition-all duration-300"
        />

        {/* Tooltip-like label for high-legibility */}
        <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-[9px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-2xl">
          Top
        </span>
      </button>
    </div>
  )
}

export default ScrollTopButton
